import { format } from "date-fns";
import { FC } from "preact/compat";
import { getChats } from "~/core/store";
import { MessagesProps } from "./interfaces";

const Messages: FC<MessagesProps> = ({ chat }) => {
    const chats = getChats();
    const messages = chats.messages(chat.rootThreadId);
    const loading = chats.isMessagesLoading(chat.rootThreadId);

    return (
        <div className="flex flex-col mt-4">
            {messages.value.length === 0 && !loading.value && (
                <div className="text-sm text-gray-500">No comments yet</div>
            )}
            {messages.value.map((message) => (
                <div key={message.id} className="flex items-center mb-3">
                    <div className="w-8 min-w-[32px] h-8 mr-2 bg-gray-200 rounded-full">
                        <span />
                    </div>
                    <div className="flex flex-col">
                        <div className="flex items-center">
                            <span className="mr-4 font-bold">
                                {message.sender.firstName}{" "}
                                {message.sender.lastName}
                            </span>
                            <span className="text-xs font-bold text-gray-500">
                                {format(
                                    new Date(message.timestamp),
                                    "dd MMM HH:mm"
                                )}
                            </span>
                        </div>
                        <span>{message.content}</span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Messages;
